module.exports = __webpack_public_path__ + "img/no_evaluation_icon_is_available.827a0412.png";